module.exports = __webpack_public_path__ + "media/mek1.cbdcc6c4.webm";